<template>
    <div class="page-content">

        <!--    页面标题 start -->
        <div v-web-title :data-title="$t('message.integral.title')"></div>
        <!--    页面标题 end -->


        <Row type="flex" justify="center">
            <!--        侧边栏 start -->
            <i-col :lg="4">
                <SideBar class="mobile-no-sidebar" />
            </i-col>
            <!--        侧边栏 end -->

            <!--            积分兑换 start-->
            <i-col :xs="24" :md="24" :lg="12">
                <div class="right-content">

                    <div class="title-block">
                        <div class="title-left">{{$t('message.integral.myProductTitle')}}</div>
                        <div class="title-right">
                            {{$t('message.integral.myScore')}}：{{userInfo.integral}}
                            <m-icons type="integral1" size="16" color="#1293f5" />
                        </div>
                    </div>

                    <div class="product-list">

                        <div v-for="product in availableProductList" :key="product.mc_id" class="product">
                            <div class="product-img">
                                <img src="../../assets/pillow.jpg" alt="product picture" />
                            </div>
                            <div class="product-name">{{product.name}}</div>
                            <div class="product-desc">{{$t('message.integral.productDesc')}}</div>
                        </div>


                    </div>

                    <div class="line line-wrapper"></div>

                    <div class="title-block">
                        <div class="title-left">{{$t('message.integral.redeemableProductTitle')}}</div>
                    </div>

                    <div class="product-list">

                        <div v-for="(product, index) in redeemableProductList" :key="product.id"
                             class="product redeemableProduct"
                             @click="showModal(index)">
                            <div class="product-img">
                                <img :src="product.src" alt="product picture" />
                            </div>
                            <div class="product-name">{{product.name}}</div>
                            <div class="product-desc">
                                <div class="score-wrapper">
                                    <m-icons class="score-icon" type="integral1" size="14" color="#1293f5" />
                                    {{product.integral}}
                                </div>
                                <div class="price-wrapper">NZ$ {{product.money}}</div>
                            </div>
                        </div>


                    </div>

                </div>
            </i-col>
            <!--            积分兑换 end-->
        </Row>

        <!--        兑换礼品对话框 start-->
        <Modal v-model="isShowRedeemModal" @on-ok="redeemProduct">
            <p slot="header">{{$t('message.integral.redeemModalTitle')}}</p>
            <p class="redeemModalText">{{redeemModalText}}</p>
        </Modal>
        <!--        兑换礼品对话框 end-->

    </div>
</template>

<script>
  import SideBar from "../../components/SideBar/SideBar";
  import mIcons from '@/components/m-icons/m-icons.vue';
  import {mapMutations, mapState} from "vuex";
  import {getLocalLang, urlRequest} from "../../common/common";

  export default {
    name: "Integral",

    data() {
      return {
        // 选中的可兑换券下标
        selectedRedeemableIndex: 0,
        // 是否展示兑换礼品对话框
        isShowRedeemModal: false,
        // 可领取礼品列表
        availableProductList: [],
        // 积分可兑换礼品列表
        redeemableProductList: [{integral: 0, name: ''}],
      }
    },

    created() {
      // 加载数据
      this.loadData();
    },

    methods: {

      ...mapMutations([
        // 保存用户信息
        'setUserInfo',
      ]),

      // 展示积分兑换对话框
      showModal(index) {
        this.selectedRedeemableIndex = index;
        this.isShowRedeemModal = true;
      },

      // 积分兑换礼品
      redeemProduct() {
        urlRequest({
          url: this.api.redeemCoupon,
          method: 'POST',
          data: {
            'id': this.redeemableProductList[this.selectedRedeemableIndex].id
          }
        }).then(res => {
          // 兑换成功后更新用户信息和可用礼品等数据
          this.loadData();
          urlRequest({
            url: this.api.me,
            method: 'GET',
          }).then(res => {
            let userInfo = res.data.msg.user;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            this.setUserInfo(userInfo);
          });
        });
      },

      // 加载数据
      loadData() {
        // 获取可领取礼品数据
        urlRequest({
          url: this.api.getAvailableCouponList,
          method: 'POST',
        }).then(res => {
          this.availableProductList = res.data.msg.filter(item => {
            return item.room_type === 0;
          });
        });
        // 获取可兑换礼品数据
        urlRequest({
          url: this.api.getRedeemableCouponList,
          method: 'POST',
        }).then(res => {
          this.redeemableProductList = res.data.msg.filter(item => {
            return item.room_type === 0;
          })
        })
      }

    },

    computed: {
      ...mapState([
        // 用户信息
        'userInfo',
      ]),

      // 积分兑换对话框国际化文本
      redeemModalText() {
        let lang = getLocalLang();
        let score = this.redeemableProductList[this.selectedRedeemableIndex].integral;
        let couponName = this.redeemableProductList[this.selectedRedeemableIndex].name;
        if (lang === 'en') {
          return `Do you want to use ${score} scores to redeem ${couponName}?`;
        } else {
          return `是否用${score}积分兑换${couponName}？`;
        }
      },
    },

    components: {
      SideBar,
      mIcons,
    },
  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "Integral.scss";

</style>
